import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import api from 'api';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { Vehicle } from 'models/Vehicle';
// import fleetManagerSocketService from 'services/socketService/fleetManagerSocketService';
// import { LISTEN_EVENTS } from 'services/socketService/socketEventNames';

import './SyncDatVehicle.styles.scss';
import './SyncDatVehicle.styles.responsive.scss';

type SyncDatVehicleProps = {
  className?: string;
  vehicleId: string;
  onSuccess?: (vahicle: Vehicle) => void;
  // onSocketEvent?: (vahicle: Vehicle) => void;
};

const SyncDatVehicle: React.FC<SyncDatVehicleProps> = (props) => {
  const { className, vehicleId, onSuccess } = props;
  const { t } = useTranslation();
  const { popError } = useContext(PopNotificationsContext);

  const classes = classNames('sync-dat-vehicle', className);

  const onSync = useCallback(async () => {
    try {
      const { data } = await api.vehicle.syncWithDat(vehicleId);
      onSuccess?.(data);
    } catch (e: any) {
      popError(e?.response?.data?.message);
    }
  }, [onSuccess, popError, vehicleId]);

  // useEffect(() => {
  //   const updateVehicle = ({ vehicle }: { vehicle: Vehicle }) => {
  //     if (vehicleId !== vehicle._id) return;
  //     onSocketEvent(vehicle);
  //   };

  //   fleetManagerSocketService.addListener(
  //     LISTEN_EVENTS.VEHICLE_UPDATE,
  //     updateVehicle,
  //   );
  //   return () => {
  //     fleetManagerSocketService.removeListener(
  //       LISTEN_EVENTS.VEHICLE_UPDATE,
  //       updateVehicle,
  //     );
  //   };
  // }, [onSocketEvent, vehicleId]);

  return (
    <Button className={classes} onClick={onSync}>
      {t('syncWithDat')}
    </Button>
  );
};

export default SyncDatVehicle;
